import React from "react";

const VideoComponent = ({workoutVideo, title,context, muscleTitle, muscleImg}) => {
  return (
    <div className="videoWrap">
      <div className="videoBox">
        <video controls loop nodownload='true'>
          <source src={workoutVideo} type="video/mp4" />
        </video>
      </div>
      <div className="videocont">
        <h3>{title}</h3>
        <p>{context}</p>
      </div>
      <div className="videocont">
        <h3>{muscleTitle}</h3>
        <div className="muscleImg">
            <img src={muscleImg} className="img-fluid" alt="" />
        </div>
      </div>
    </div>
  );
};

export default VideoComponent;
